<template>
    <div class="superbill-form">

        <b-row>
            <b-col cols="12" md="7" lg="8">
                <div class="superbill-form__codes-frame">
                    <b-row>
                        <b-col cols="6" lg="3"
                               v-for="(cptCode,i) in superbill.cptCodes" :key="`code_${i}`">
                            <b-form-checkbox button class="my-2 code-checkbox"
                                             button-variant="default"
                                             v-model="cptCode.checked">
                                <div class="cpt-code">
                                    {{ cptCode.code }}
                                </div>
                                <div class="cpt-description">
                                    {{ getPracticeCode(cptCode).description }}
                                </div>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="12" md="5" lg="4">
                <h4>{{ $i18n.gt('HEADING_CPT_CODES') }}</h4>
                <div class="mb-2"
                     v-for="(cptCode,j) in checkedCptCodes" :key="`cpt_${j}`">
                    <strong>{{ cptCode.code }}</strong>
                    {{ getPracticeCode(cptCode).description }}
                    <span class="superbill-form__charge">
                        ${{ getPracticeCode(cptCode).charge }}
                    </span>
                    <br/>
                    <b-form-select class="superbill-form__select mx-2 mb-2"
                                   :options="[{value: null, text: 'Modifier'}, '-02', '-11', '-95']"
                                   v-model="cptCode.modifier">
                    </b-form-select>
                    <b-form-select class="superbill-form__select mb-2"
                                   :options="[{value: null, text: 'Minutes'}, 10, 15, 20, 30, 40, 60, 90]"
                                   v-model="cptCode.minutes">
                    </b-form-select>
                </div>

                <h4>{{ $i18n.gt('HEADING_DIAGNOSIS_CODES') }}</h4>
                <div v-for="k in [0,1,2,3,4]" :key="`dx_${k}`">
                    <b-form-input type="text" class="mb-3"
                                  v-model="superbill.dxCodes[k]">
                    </b-form-input>
                </div>

                <h4>{{ $i18n.gt('HEADING_CONDITION_RELATED') }}</h4>
                <b-form-checkbox v-model="superbill.conditionRelatedTo.employment">
                    {{ $i18n.gt('LABEL_EMPLOYMENT') }}
                </b-form-checkbox>
                <b-row>
                    <b-col>
                        <b-form-checkbox v-model="superbill.conditionRelatedTo.autoAccident">
                            {{ $i18n.gt('LABEL_AUTO_ACCIDENT') }}
                        </b-form-checkbox>
                    </b-col>
                    <b-col v-if="superbill.conditionRelatedTo.autoAccident">
                        <b-form-input type="text" placeholder="State"
                                      v-model="superbill.conditionRelatedTo.autoAccidentPlace">
                        </b-form-input>
                    </b-col>
                </b-row>
                <b-form-checkbox v-model="superbill.conditionRelatedTo.otherAccident">
                    {{ $i18n.gt('LABEL_OTHER_ACCIDENT') }}
                </b-form-checkbox>
            </b-col>
        </b-row>

        <div class="float-right">
            <b-btn class="btn btn-default"
                   @click="save()">
                {{ $i18n.gt('LABEL_SAVE') }}
            </b-btn>
        </div>

    </div>
</template>

<script>

import * as _ from 'lodash'

/**
 * Displays a form for selecting superbill codes from a rubric, in order to generate a superbill in
 * conjunction with a SurveyNote
 */
export default {
    name: 'SuperbillForm',
    props: {
        surveyNote: Object
    },
    data() {
        return {}
    },
    computed: {
        superbill() {
            return this.surveyNote.superbill
        },
        practiceSuperbillCodes() {
            return this.$store.state.currentUser.practitionerPracticeSuperbillCodes
        },
        checkedCptCodes() {
            return _.filter(this.superbill.cptCodes, (code) => {
                return code.checked
            })
        },
        canSave() {
            return true
        },
        modalId() {
            return `superbillModal_${this.surveyNote.id}`
        },
    },
    methods: {
        getPracticeCode(cptCode) {
            return _.find(this.practiceSuperbillCodes, (psc) => psc.code == cptCode.code)
        },
        async save() {
            try {
                // TODO: limit to 6 CPT codes? (max supported on Form 1500 - see Form1500Service)
                await this.$api.updateItem(this, 'survey-note', this.surveyNote)

                this.$toasted.show('Superbill saved', {duration: 3000})
                this.$bvModal.hide(this.modalId) // TODO: cleanup? (referring to parent's modal)

                // reload participant and notes, etc.
                this.$store.dispatch('getPatientParticipant', {
                    participantId: this.surveyNote.participant_id,
                    force: true
                })
            } catch (e) {
                this.$utils.handleError(e, 'Could not save Superbill')
            }
        },
    },
    mounted() {
        // initialize cptCodes on superbill, based on practice codes
        // (set these for the first time, and make sure new ones haven't been introduced for the practice)
        _.each(this.practiceSuperbillCodes, (practiceCode) => {
            const billCode = _.find(this.superbill.cptCodes, (bcode) => bcode.code == practiceCode.code)
            if (!billCode) {
                console.log('SuperbillForm:mounted  adding billCode')
                this.superbill.cptCodes.push({
                    code: practiceCode.code,
                    modifier: null,
                    minutes: null
                })
            }
        })
    },
}

</script>

<style lang="scss">

.superbill-form__codes-frame {
    background-color: #f9f9f9;
    padding: 5px 10px;
}

.superbill-form__select {
    width: 45% !important;
}

.superbill-form__charge {
    color: #ccc !important;
    padding-left: 20px;
}

.code-checkbox {
    width: 100%;
    border: solid 1px #ccc;
    background-color: #fff;
    border-radius: 3px;

    .btn {
        border-radius: 0;
    }

    label {
        color: #333 !important;
        padding: 10px;

        &.active {
            background: pink;
        }

        .cpt-code {
            position: absolute;
            top: 10px;
            left: 18px;
        }

        .cpt-description {
            margin: 5px 0 0 0 !important;
        }
    }
}

</style>
